import React, { useState, useEffect } from "react";

export default function NailPara() {
  const [isLargeScreen, setIsLargeScreen] = useState(() =>
            window.matchMedia("(min-width: 1280px)").matches
          );
           useEffect(() => {
              const mediaQuery = window.matchMedia("(min-width: 1280px)");
              const handleChange = (e) => setIsLargeScreen(e.matches);
              mediaQuery.addEventListener("change", handleChange);
          
              return () => {
                mediaQuery.removeEventListener("change", handleChange);
              };
            }, []);
  return (
    <>
    {isLargeScreen&&
    <div className=" w-100  d-flex justify-content-center">
          <div className="m-0 up-5 bg-gray-light  w-75  br-5 box-shadow ">
  

    <p className="ufs-5 fw-bold text-blue ">Precision in Every Millimeter</p>
    <ul className="ufs-4 m-0 upy-2 ">
    <li className=" ufs-4 fw-bold m-0 upy-1">With physician-programmed distraction protocols and the ability to safely bear weight throughout treatment, our device ensures a smoother, safer, and smarter path to limb lengthening.</li>
    <li className=" ufs-4 fw-bold m-0 upy-1">Whether for treating limb length discrepancies, congenital deformities, or post-traumatic corrections — our device is designed for better outcomes and better lives.</li>
    <li className=" ufs-4 fw-bold m-0 upy-1 ">Discover the future of orthopedic care. Experience distraction without disruption.</li>
    </ul>
              </div>
    </div>
    }
    {!isLargeScreen&&
      <div className=" d-flex px-2 justify-content-center w-100 my-4 ">
      <div className="m-0 px-3 bg-gray-light   w-100  br-5 box-shadow ">
         
      <p className="ufs-11 fw-bold text-blue m-0 p-0">Precision in Every Millimeter</p>
      <ul className=" m-0 upy-2 px-0">
      <li className=" ufs-9 fw-bold m-0 upy-1 px-0">With physician-programmed distraction protocols and the ability to safely bear weight throughout treatment, our device ensures a smoother, safer, and smarter path to limb lengthening.</li>
      <li className=" ufs-9 fw-bold m-0 upy-1 px-0">Whether for treating limb length discrepancies, congenital deformities, or post-traumatic corrections — our device is designed for better outcomes and better lives.</li>
      <li className=" ufs-9 fw-bold m-0 upy-1 px-0 ">Discover the future of orthopedic care. Experience distraction without disruption.</li>
      </ul>
      </div>
      </div>
    }
    </>
    
  )
}
